import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteExecution } from '../Api'

export default generateApiAction({
  baseType: Types.EXECUTIONS.DELETE,
  api: deleteExecution,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/executions/DeleteAction.js